function parseRouteQuery (query, raiseException = false, defaultResponse = null) {
  if (query == null || query.by == null || query.tag == null) {
    if (raiseException) {
      throw 'Missing query error';
    } else {
      return defaultResponse;
    }
  }

  const searchBy = query.by.toLowerCase();
  if (searchBy !== 'skill' && searchBy !=='name') {
    if (raiseException) {
      throw 'Query value error';
    } else {
      return defaultResponse;
    }
  }

  const searchInput = [];
  const tag = query.tag;
  if (typeof tag === 'string') {
    if (tag.trim().length > 0) {
      searchInput.push(tag);
    } else if (raiseException) {
      throw 'Search input error';
    } else {
      return defaultResponse;
    }
  } else if (tag instanceof Array) {
    if (tag.filter(elem => elem.trim().length > 0).length > 0) {
      searchInput.push(...tag);
    } else if (raiseException) {
      throw 'Search inputs error';
    } else {
      return defaultResponse;
    }
  }

  const searchBySkill = searchBy === 'skill';
  return {
    searchInput: searchInput,
    searchBySkill: searchBySkill,
  };
}

export {
  parseRouteQuery,
};
